import {Injectable} from "@angular/core";
import {AddressFormComponent} from "../address-form/address-form.component";
import {HttpClient} from "@angular/common/http";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from "@angular/material/dialog";
import {AddBillingService} from "./add-billing.service";
import Swal from 'sweetalert2';

@Injectable({
    providedIn: 'root'
})

export class AddressService {
    private datosSeleccionados: any;
    addresses: any[] = [];

    constructor(private http: HttpClient,
                private snackBar: MatSnackBar,
                private dialog: MatDialog,
                private addBilling: AddBillingService) {}

    setAddress(datos: any) {
        this.datosSeleccionados = datos;
    }

    getAddress() {
        return this.datosSeleccionados;
    }

    seleccionarDatos(address: any, router: any, serviceAddress: any) {
        console.log('Datos seleccionados', address);
        serviceAddress.setAddress(address);
        router.navigate(['/generaF']);
    }

    async deleteAddress(id: string, formBuilder: any, callback?: () => void) {
        console.log('deleteAddress', id);

        const formDelete = formBuilder.group({
            username: localStorage.getItem('userEmail') || '',
            password: localStorage.getItem('password') || '',
            id: id
        });

        const confirmacion = await Swal({
            title: '¿Deseas eliminar esta dirección?',
            text: 'Selecciona una opción:',
            showCancelButton: true,
            confirmButtonColor: '#38a845',
            cancelButtonColor: '#e55858',
            confirmButtonText: 'Si, eliminar',
            cancelButtonText: 'No, cancelar',
            allowOutsideClick: false,
            allowEscapeKey: false,
            reverseButtons: true
        });

        if (confirmacion.value) {
            this.addBilling.deleteBillingAddress(formDelete.value).subscribe({
                next: (response) => {
                    console.log('Datos eliminados correctamente', response);
                    this.snackBar.open('Datos eliminados correctamente.', 'Cerrar', {
                        duration: 3000,
                        horizontalPosition: 'center',
                        verticalPosition: 'top',
                        panelClass: ['success-snackbar']
                    });

                    this.addBilling.getBillingAddresses().subscribe({
                        // tslint:disable-next-line:no-shadowed-variable
                        next: (response) => {
                            console.log('Datos obtenidos', response);
                            this.addresses = response.addresses;
                            localStorage.setItem('addresses', JSON.stringify(this.addresses));

                            // 🔹 Verifica que `callback` sea una función antes de llamarlo
                            if (typeof callback === 'function') {
                                callback();  // Llamamos al callback para actualizar la vista
                            }
                        },
                        error: (error) => {
                            console.log('Error al obtener las direcciones:', error);
                        }
                    });
                },
                error: (error) => {
                    console.log('Error al eliminar los datos', error);
                }
            });
        }
    }

    addAddress(callback: () => void) {
        const addAddresses = this.dialog.open(AddressFormComponent, {
            panelClass: 'custom-dialog-panel',
            width: '800px',
            maxHeight: '90vh'
        });
        addAddresses.afterClosed().subscribe(result => {
            if (result) {
                console.log('Datos guardados', result);
                this.addBilling.getBillingAddresses().subscribe({
                    next: (response) => {
                        console.log('Datos obtenidos', response);
                        this.addresses = response.addresses;
                        localStorage.setItem('addresses', JSON.stringify(this.addresses));

                        if (callback) {
                            callback(); // Llamamos a la función callback para actualizar la vista
                        }
                    },
                    error: (error) => {
                        console.log('Error al obtener las direcciones:', error);
                    }
                });
            }
        });
    }
}
